import { checkoutWorkKey, sameCheckoutWork } from "./postOpSuggestions";

export function checkoutDraftItemIdentity(item) {
  const workKey = checkoutWorkKey(item);
  if (workKey) return `work:${workKey}`;
  if (item?.draft_line_id) return `draft:${item.draft_line_id}`;
  if (item?.id) return `legacy:${item.id}`;
  return null;
}

export function mergeCheckoutDraftItems(localItems, serverItems) {
  const out = [];
  const seen = new Set();

  for (const item of [
    ...(Array.isArray(localItems) ? localItems : []),
    ...(Array.isArray(serverItems) ? serverItems : []),
  ]) {
    const identity = checkoutDraftItemIdentity(item);
    if (identity && seen.has(identity)) continue;
    if (identity) seen.add(identity);
    out.push(item);
  }

  return out;
}

export function dropDeadPlanDraftLines(draftItems, scheduledItems) {
  const items = Array.isArray(draftItems) ? draftItems : [];
  const livePlanIds = new Set();
  for (const s of (Array.isArray(scheduledItems) ? scheduledItems : [])) {
    if (s?.treatment_plan_id) livePlanIds.add(s.treatment_plan_id);
  }
  const kept = [];
  let dropped = 0;
  for (const it of items) {
    const isCompletedClinicalVisit = !!it?.procedure_visit_id && (it?.outcome || "done") === "done";
    if (
      it?.treatment_plan_id
      && !livePlanIds.has(it.treatment_plan_id)
      && !isCompletedClinicalVisit
    ) {
      dropped += 1;
      continue;
    }
    kept.push(it);
  }
  return { items: kept, dropped };
}

function matchScheduledRow(item, scheduled, orthoByCaseVisit) {
  for (const row of scheduled) {
    if (sameCheckoutWork(item, row)) return row;
  }
  if (item?.source === "ortho_checkout" && item.ortho_case_id && item.ortho_visit_type) {
    return orthoByCaseVisit.get(`${item.ortho_case_id}:${item.ortho_visit_type}`) || null;
  }
  return null;
}

function canonicalizeScheduledDraftItem(item, scheduledRow) {
  const merged = {
    ...item,
    ...scheduledRow,
  };
  return {
    ...merged,
    outcome: item.outcome || scheduledRow.outcome || "done",
    performed_price_centavos:
      item.performed_price_centavos
      ?? scheduledRow.performed_price_centavos
      ?? scheduledRow.display_price_centavos
      ?? scheduledRow.default_fee_centavos,
    item_discount_centavos: item.item_discount_centavos ?? 0,
    qty: item.qty ?? 1,
  };
}

export function repairDraftItemsWithScheduled(draftItems, scheduledItems) {
  const scheduled = Array.isArray(scheduledItems) ? scheduledItems : [];
  const orthoByCaseVisit = new Map();
  for (const row of scheduled) {
    if (row?.source !== "ortho_checkout") continue;
    if (row.ortho_case_id && row.ortho_visit_type) {
      orthoByCaseVisit.set(`${row.ortho_case_id}:${row.ortho_visit_type}`, row);
    }
  }

  const out = [];
  const seenItemIdentities = new Set();
  for (const item of (Array.isArray(draftItems) ? draftItems : [])) {
    const scheduledRow = matchScheduledRow(item, scheduled, orthoByCaseVisit);
    const next = scheduledRow
      ? canonicalizeScheduledDraftItem(item, scheduledRow)
      : item;
    const identity = checkoutDraftItemIdentity(next);
    if (identity && seenItemIdentities.has(identity)) continue;
    if (identity) seenItemIdentities.add(identity);
    out.push(next);
  }
  return out;
}
